'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { getFullHref } from '../../utils/history';
import CoreCanonicalLink from 'ecosystem-marketplace-core/components/elements/CanonicalLink';

const CanonicalLink = (_ref) => {
  let {
    to
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["to"]);

  return /*#__PURE__*/_jsx(CoreCanonicalLink, Object.assign({}, rest, {
    href: getFullHref(to).replace(/\/$/, '')
  }));
};

CanonicalLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};
export default CanonicalLink;